export class UpdateHandOver {
    Id: number;
    Code: string;
    Name: string;
    HandOverHubId: number;
    HandOverEmpId: number;
    HandOverReceiverEmpId: number;
    HandOverStatusId: number;
    isEnabled: boolean = true;
}